import React from 'react';
import styles from './MenuItem.module.scss';
import PropTypes from 'prop-types';
// import { useTranslation } from 'react-i18next';

const MenuItem = ({ icon, title, isActive, onClick }) => {
  // const { t } = useTranslation();
  return (
    <div
      className={styles['title_container']}
      onClick={() => {
        onClick && onClick();
      }}
      tabIndex={0}
      role="button"
      onKeyDown={() => {}}
    >
      <div
        className={
          isActive ? styles['title_inner_container_active'] : styles['title_inner_container']
        }
      >
        <div className={styles['menu_icon']}>
          <img src={icon} width={24} height={24} alt="icon" />
        </div>
        <div className={styles['menu_title_container']}>
          <p className={styles['menu_title']}>{title}</p>
        </div>
      </div>
    </div>
  );
};

MenuItem.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};

export default MenuItem;
